import { Link } from '@tanstack/react-router';
import { todayInDhaka } from '@thrivehrm/shared';
import { StatTile } from '@/components/ui/stat-tile';
import { StatTilesSkeleton, WidgetError } from '@/features/dashboard/widget-states';
import { useMyLeave } from './api';

/**
 * My leave balances at a glance (FR-LEAVE-8, ARCHITECTURE §8.4 dashboard widgets): days
 * available per type with a balance and what pending requests reserve, linking to My leave.
 */
export function LeaveBalanceWidget() {
  const mine = useMyLeave(Number(todayInDhaka().slice(0, 4)));
  if (mine.isPending) return <StatTilesSkeleton count={2} />;
  if (mine.error) {
    return <WidgetError onRetry={() => void mine.refetch()} retrying={mine.isRefetching} />;
  }
  const types = mine.data.types.filter((t) => t.hasBalance);
  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 gap-2">
        {types.map((t) => (
          <StatTile
            key={t.leaveTypeId}
            label={<span title={t.name}>{t.name}</span>}
            value={t.available ?? 0}
            note={t.pending > 0 ? `${String(t.pending)} reserved` : undefined}
          />
        ))}
      </div>
      <Link to="/me/leave" className="w-fit text-small font-semibold text-primary hover:underline">
        Apply for leave
      </Link>
    </div>
  );
}
